import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from 'projects/autofacets-infrastructure/src/Autofacets.Infrastructure.Services/data-service/data.service';
import { GenericResponse } from 'projects/autofacets-infrastructure/src/Autofacets.Infrastructure.Generic/af-generic-response/af-genericResponse';
import { UserDetails } from 'projects/autofacets-infrastructure/src/Autofacets.Infrastructure.Common/Model/UserDetails';
import { EncryptionService } from '../../Autofacets.Infrastructure.Security/Encryption/encryption.service';

@Injectable({ providedIn: 'root' })
export class UserDataService {
  private readonly baseURL = environment.packageToolApiUrl;
  private readonly genericApiURL = environment.genericApiURL;

  constructor(
    private readonly dataService: DataService,
    private readonly encryptionService: EncryptionService
  ) { }

  public GetUserDetails() {
    return this.dataService
      .GetAll<GenericResponse<UserDetails>>(this.baseURL + 'PackagePortal/GetLoggedInUserDetails')
      .toPromise();
  }

  public GetToken() {
    return this.dataService
      .Get<string>(this.baseURL + 'Token/GetToken')
      .toPromise();
  }

  async getIfDarsV2Dealer(dealerId: string, dealerNo: string){
    return await this.dataService.Get<GenericResponse<boolean>>(this.genericApiURL + 'Dealer/IsActiveDarsVersion2/' + this.encryptionService.encryptURLParameters(dealerId.toString()) + '/' + this.encryptionService.encryptURLParameters(dealerNo.toString())).toPromise();
  }
}
